import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from '../../components/Header/parts/Title';
import { getSmallImage } from '../../utils/prismic';

const ListContainer = styled.ul`
  padding-bottom: 8rem;
  position: relative;
  display: flex;
  width: 100;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
`;
const ListItem = styled.li`
  flex-basis: 20%;
  flex-grow: 1;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 2.4rem;
  text-align: center;
`;

const ListImages = ({ input }) => (
  <>
    <Title
      title={input.primary.title.html}
      subtitle={input.primary.subtitle.html}
      description={input.primary.description.html}
      title_align={input.primary.align_text}
    />
    <ListContainer>
      {input &&
        input.items &&
        input.items.map(({ image, caption }, index) => (
          <ListItem key={index}>
            <img
              src={getSmallImage(image).url}
              alt={getSmallImage(image).alt}
              width={getSmallImage(image).width}
              height={getSmallImage(image).height}
            />
            <span
              className="caption"
              dangerouslySetInnerHTML={{
                __html: caption.html,
              }}
            />
          </ListItem>
        ))}
    </ListContainer>
  </>
);

export default ListImages;

ListImages.propTypes = {
  input: PropTypes.object.isRequired,
};

//src={x.file.localFile.childImageSharp.fluid}
//<Img fluid={x.image.localFile.childImageSharp.fluid} />
